
declare var dataLayer: any;
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {
    PasswordInput: () => import("./PasswordInput.vue")
  }
})
export default class ForgotPass extends Vue {
  @Prop(Boolean) openLogin!: boolean;
  email_forgot = "";
  password1 = "";
  password2 = "";
  error = null;
  success = null;
  changePass = false;
  hash = Math.random() * 100000;

  @Watch("openLogin")
  onChangeIsUniSearch(val: string) {
    if (!status) {
      this.changePass = false;
    }
  }

  onPasswordChange(value: any) {
    (this as any).password1 = value.target.value;
  }

  onPasswordChangeConfirm(value: any, type: any) {
    (this as any).password2 = value.target.value;
  }

  async submitCreatePass() {
    const _this: any = this;
    if (_this.email_forgot) {
      try {
        var response = await _this.$root._post("user/recoverpassword", {
          email: _this.email_forgot
        });
        _this.success = response.status
          ? `Éxito. Recibirá un correo a la cuenta ${_this.email_forgot} con las instrucciones para recuperar su contraseña. Muchas gracias.`
          : "";
      } catch (e) {
        console.log(e);
        _this.error =
          e.message === "No token available"
            ? "El usuario no existe"
            : e.message;
        setTimeout(() => {
          _this.error = null;
        }, 2000);
      }
    } else {
      (this as any).email_forgot = null;
    }
  }

  async submitNewPass() {
    const _this: any = this;
    try {
      if (
        !_this.password1 ||
        !_this.password2 ||
        _this.password1 !== _this.password2
      ) {
        _this.error = "Las contraseñas no coinciden o son inválidas.";
        setTimeout(() => {
          _this.error = null;
        }, 2000);
      } else {
        const token: string = atob(_this.$route.params.token);
        let url: any = window.location.href.split("/");
        url.pop();
        var response = await _this.$root._put("user/changepassword", {
          email: token.substring(10, token.length - 9),
          password: _this.password1
        });
        (window as any).location = url.join("/");
        dataLayer.push({
          event: "Event",
          category: "engagement",
          action: "password_reset"
        });
      }
    } catch (e) {
      _this.error = e.message;
      setTimeout(() => {
        _this.error = null;
      }, 2000);
    }
  }

  resetModal() {
    document.body.classList.remove("scroll-lock");
    document.body.classList.remove("scroll-lock-with-fix");
    this.changePass = false;
    //this.openLogin = false;
  }

  mounted() {
    if ((this as any).$route.params.token) (this as any).changePass = true;
  }
}
